<div class="app">
  <main class="wrapper">
    <svelte:component this={ route } {params} />
  </main>
</div>

<script>
  import page from 'page';
  import { Store } from 'svelte/store.js';

  const modelVersion = '003';
  const activitiesStorageKey = `path-activities-v${modelVersion}`;
  const projectsStorageKey = `path-projects-v${modelVersion}`;
  const tipsStorageKey = `path-tips-v${modelVersion}`;

  const activities = () => {
    try {
      return JSON.parse(localStorage.getItem(activitiesStorageKey))|| {};
    } catch (err) {
      return {};
    }
  }

  const defaultProjects = {
    family: [],
    friends: [],
    self: [],
    work: [],
  };
  const projects = () => {
    try {
      return JSON.parse(localStorage.getItem(projectsStorageKey))|| defaultProjects;
    } catch (err) {
      return defaultProjects;
    }
  }

  const tips = () => {
    try {
      return JSON.parse(localStorage.getItem(tipsStorageKey))|| {};
    } catch (err) {
      return {};
    }
  }

  const store = window.store = new Store({
    activities: activities(),
    completedActivities: [],
    draggedActivity: null,
    draggedOver: null,
    draggedProject: null,
    editedActivity: null,
    editedProject: null,
    mode: {
      activities: 'normal',
      projects: 'normal',
    },
    projects: projects(),
    selectedActivity: {},
    selectedProject: {},
    selectedQuadrant: null,
    tips: tips(),
    version: '1.8.3',
  });

  store.compute(
    'currentProjects',
    ['projects', 'selectedQuadrant'],
    (projects, selectedQuadrant) => projects[selectedQuadrant]
  );

  export default {
    store: () => store,
    data() {
      return {
        route: null,
        params: {},
      }
    },
    oncreate() {
      let store = this.store;
      const defaultMode = {
        activities: 'normal',
        projects: 'normal',
      };

      const listener = this.store.on('state', ({ changed, current, previous }) => {
        if (previous && changed.activities) {
          try {
            localStorage.setItem(activitiesStorageKey, JSON.stringify(current.activities));
          } catch (err) {}
        }
        if (previous && changed.projects) {
          try {
            localStorage.setItem(projectsStorageKey, JSON.stringify(current.projects));
          } catch (err) {}
        }
        if (previous && changed.tips) {
          try {
            localStorage.setItem(tipsStorageKey, JSON.stringify(current.tips));
          } catch (err) {}
        }
      });
      this.on('destroy', listener.cancel);

      const draw = (m, params) => {
        params = params || {};
        this.set({ route:m.default, params });
      }

      function track(obj) {
        store.set({ mode: defaultMode });

        if (window.ga) {
          ga.send('pageview', { dp:obj.uri });
        }
      }

      addEventListener('popstate', track);
      addEventListener('pushstate', track);
      addEventListener('replacestate', track);

      page('/', (ctx) => {
        import('@pages/Home').then(draw);
      });
      page('/projects/:quadrant', (ctx) => {
        import('@pages/Projects').
          then(m => draw(m, ctx.params));
      });
      page('/projects/:quadrant/:project', (ctx) => {
        import('@pages/Activities').
          then(m => draw(m, ctx.params));
      });
      page({ hashbang: true });
    }
  };
</script>

<style>.app {
  position: relative; }

.wrapper {
  width: 75%;
  margin: 0 auto;
  position: relative;
  min-height: calc(55vh - 16px);
  z-index: 1; }

@media screen and (max-width: 769px) {
  .wrapper {
    width: 90%; } }

/*# sourceMappingURL=App.html.css.map */</style>
